import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import { getShopBrandId } from '../../../../../auth/selectors';
import { manageProductsConnection } from '../../actions';
import { MATCHES_ARCHIVED_STATUS, MATCHES_CONNECTED_STATUS, MATCHES_PENDING_STATUS } from '../../../constants';
import { fetchMatches as fetchMatchesAction, resetMatches as resetMatchesAction } from '../../reducer/actions';
import { getMatchesInitializeStatus } from '../../selectors';
import withNotifications from '../../../../../common/withNotifications';

const mapStateToProps = state => ({
  allSelected: state.shopify.shopifyMatches.allSelected,
  brandId: getShopBrandId(state),
  loadingMatches: state.shopify.shopifyMatches.loading,
  matchesInitialized: getMatchesInitializeStatus(state),
  selectedItems: state.shopify.shopifyMatches.selectedItems,
  shopifySettings: state.shopify.shopifySettings.settings,
});

const withMatchesManagement = compose(
  withNotifications,
  connect(mapStateToProps, {
    fetchMatches: fetchMatchesAction,
    resetMatches: resetMatchesAction,
  }),
  withHandlers({
    reFetchMatches: ({ brandId, fetchMatches, resetMatches, shopifySettings, status }) => () => {
      resetMatches();
      fetchMatches(brandId, shopifySettings, status);
    },
  }),
  withHandlers({
    onArchive: ({ addNotification, brandId, reFetchMatches, selectedItems }) => () => {
      manageProductsConnection(brandId, 'shopify', selectedItems, MATCHES_ARCHIVED_STATUS)
        .then(() => {
          addNotification({
            title: 'Success',
            level: 'success',
            message: 'Products have been dismissed.',
          });

          reFetchMatches();
        });
    },
    onLink: ({ addNotification, brandId, reFetchMatches, selectedItems }) => () => {
      manageProductsConnection(brandId, 'shopify', selectedItems, MATCHES_CONNECTED_STATUS)
        .then(() => {
          addNotification({
            title: 'Success',
            level: 'success',
            message: 'Products have been linked in Commander and Shopify and can be found in Linked Products tab.',
          });

          reFetchMatches();
        });
    },
    onRestore: ({ addNotification, brandId, reFetchMatches, selectedItems }) => () => {
      manageProductsConnection(brandId, 'shopify', selectedItems, MATCHES_PENDING_STATUS)
        .then(() => {
          addNotification({
            title: 'Success',
            level: 'success',
            message: 'Products have been restored.',
          });

          reFetchMatches();
        });
    },
  }),
);

export default withMatchesManagement;
